import { getMeta } from './get-meta';

const sendSeenTransactionEvent = (transactionItem) => {
    const transactionSeenUrl = transactionItem.getAttribute(
        'data-transaction-seen-post-url'
    );

    fetch(transactionSeenUrl, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': getMeta('csrf-token'),
        },
    })
        .then((response) => {
            if (response.ok) {
                transactionItem.setAttribute(
                    'data-seen-event-sent-successfully',
                    'true'
                );
            }
        })
        .catch((error) => {
            console.error(error);
        });
};

const handleIntersect = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            sendSeenTransactionEvent(entry.target);
            observer.unobserve(entry.target);
        }
    });
};

export const toggleTransactionHandler = (toggleButton) => {
    const transactionItem = toggleButton.closest(
        toggleButton.getAttribute('data-target')
    );
    const transactionItemBody = transactionItem.querySelector(
        '.js-transaction-item__body'
    );
    const isTransactionOpen =
        transactionItem.getAttribute('data-is-open') === 'true';

    transactionItem.setAttribute('data-is-open', !isTransactionOpen);
    transactionItem.setAttribute('data-is-opened', 'true'); // Hides "unread" label
    toggleButton.setAttribute('aria-expanded', !isTransactionOpen);
    transactionItemBody.setAttribute('aria-hidden', isTransactionOpen);
};

export const transactionOverviewEnhancer = (el) => {
    const observer = new IntersectionObserver(handleIntersect, {
        threshold: 1,
    });
    const unseenTransactionItems = el.querySelectorAll(
        '.js-transaction-item[data-is-unseen="true"]'
    );

    unseenTransactionItems.forEach((item) => {
        observer.observe(item);
    });
};
